'use client';

import React, { useState } from 'react';
import { ActionsTab } from '@/app/dashboard/tech-support/domains/components/actions-tab';
import { DetailsTab } from '@/app/dashboard/tech-support/domains/components/details-tab';
import { DNSTab } from '@/app/dashboard/tech-support/domains/components/dns-tab';
import { JSONTab } from '@/app/dashboard/tech-support/domains/components/json-tab';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';
import { Divider, Tab, Tabs } from '@mui/material';
import { Stack } from '@mui/system';

import { DomainDetailsTab, GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function DomainDetailsDrawer(): React.JSX.Element {
  const { drawerState } = useAppSelector(getUi);
  const dispatch = useAppDispatch();

  const [tabValue, setTabValue] = useState(DomainDetailsTab.DETAILS);
  const tabList = [
    {
      id: DomainDetailsTab.DETAILS,
      label: 'Details',
      content: <DetailsTab />,
    },
    {
      id: DomainDetailsTab.DNS,
      label: 'DNS',
      content: <DNSTab />,
    },
    {
      id: DomainDetailsTab.ACTIONS,
      label: 'Actions',
      content: <ActionsTab />,
    },
    {
      id: DomainDetailsTab.JSON,
      label: 'JSON',
      content: <JSONTab />,
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: DomainDetailsTab): void => {
    setTabValue(newValue);
  };

  return (
    <DrawerTemplate
      open={drawerState.DOMAIN_DETAILS}
      onClose={() => dispatch(hideDrawerState(GeneralDrawer.DOMAIN_DETAILS))}
      title="Domain Details"
      width="700px"
    >
      <Tabs value={tabValue} onChange={handleChange}>
        {tabList.map((item) => (
          <Tab key={item.id} label={item.label} value={item.id} />
        ))}
      </Tabs>
      <Divider />
      {tabList.map((item) => (
        <Stack sx={{ pt: 2, display: item.id === tabValue ? 'flex' : 'none' }} key={item.id}>
          {item.content}
        </Stack>
      ))}
    </DrawerTemplate>
  );
}
